import React, { useEffect, useRef } from "react";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCheckoutSessionMutation,
  useGetPlansQuery,
} from "@/features/auth/api/authAPI";
import { ResponsePlans } from "@/features/auth/types/auth";
import BillingPlanMonth from "@/shared/ui/BillingPlanMonth/BillingPlanMonth";
import BillingPlanTeams from "@/shared/ui/BillingPlanTeams/BillingPlanTeams";
import styles from "./BillingPage.module.scss";
import { useCurrentOrganization, useMe } from "@/Hooks";
import Spinner from "@/shared/ui/Spinner/Spinner";
import mixpanel from "@/shared/lib/mixpanel";
import { User, Users, XIcon } from "lucide-react";

interface BillingPageProps {
  isOpen: boolean;
  onClose: () => void;
}

const BillingPage = ({ isOpen, onClose }: BillingPageProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  //const [referral, setReferral] = React.useState();
  //const [referralCouponId, setReferralCouponId] = React.useState();

  const [toltReferral, setToltReferral] = React.useState();
  const [toltPartner, setToltPartner] = React.useState();

  const { me } = useMe();
  const currentOrg = useCurrentOrganization();
  const [activeMenuItem, setActiveMenuItem] = React.useState("individual");
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [pendingPlanData, setPendingPlanData] = React.useState<string | null>(
    null,
  );
  const [sliderValue, setSliderValue] = React.useState<number>(5);
  const { data: apiDataPlans, isLoading } = useGetPlansQuery();
  const navigate = useNavigate();
  const [createCheckoutSession] = useCheckoutSessionMutation();

  const previousActiveMenuItemRef = useRef(activeMenuItem);

  const params = useParams();

  console.log(params.uuid);

  useEffect(() => {
    if (!modalRef.current) {
      return;
    }

    const handleClickOutside = (e: MouseEvent) => {
      const modalContainer = document.querySelector("#BillingModalContainer");

      if (
        e.target.id !== "unlockProButton" &&
        !modalContainer?.contains(e.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    // window.rewardful("ready", () => {
    //   setReferral(window.Rewardful.referral);
    //   if (window.Rewardful.coupon) {
    //     setReferralCouponId(window.Rewardful.coupon.id);
    //   }
    // });

    if (window.tolt !== undefined && window.tolt !== null) {
      setToltReferral(window.tolt_referral);
      setToltPartner(window.tolt_data?.partner_id);
    }
  }, []);

  const handleSliderChange = (value: number | number[]) => {
    typeof value === "number"
      ? setSliderValue(value)
      : setSliderValue(value[0]);
  };

  const handleMenuItemClick = (item: "individual" | "teams") => {
    if (activeMenuItem !== item) {
      // Only track if the item actually changes
      mixpanel.track("Billing Plan Type Selected", {
        plan_type_selected: item,
        previous_plan_type_selected: previousActiveMenuItemRef.current,
        organization_id: currentOrg?.uuid || null,
        user_id: me?.id || null,
        user_email: me?.email || null,
      });
      setActiveMenuItem(item);
    }
  };

  useEffect(() => {
    //const pendingPlan = localStorage.getItem("pendingPlanPurchase");
    //setPendingPlanData(pendingPlan);
    // if (pendingPlan && currentOrg?.uuid) {
    //   const planData = JSON.parse(pendingPlan);
    //   setActiveMenuItem(planData.menuItem || "individual");
    //   if (planData.qte) {
    //     setSliderValue(planData.qte);
    //   }
    //   const timer = setTimeout(() => {
    //     handleSelectPlan(planData.priceId, planData.qte);
    //     localStorage.removeItem("pendingPlanPurchase");
    //     localStorage.removeItem("showBillingAfterVerification");
    //     setPendingPlanData(null);
    //   }, 3000);
    //   return () => clearTimeout(timer);
    // }
  }, [currentOrg?.uuid]);

  // useEffect(() => {
  //   if (!isOpen) {
  //     localStorage.removeItem("showBillingAfterVerification");
  //   }
  // }, [isOpen]);

  const handleSelectPlan = async (priceId: string, qte: number) => {
    if (!currentOrg?.uuid) {
      // localStorage.setItem(
      //   "pendingPlanPurchase",
      //   JSON.stringify({
      //     priceId,
      //     qte,
      //     menuItem: activeMenuItem,
      //     timestamp: Date.now(),
      //   }),
      // );

      //localStorage.setItem("showBillingAfterVerification", "true");
      navigate("/register");
      return;
    }

    setIsProcessing(true);

    try {
      const data = await createCheckoutSession({
        priceId: priceId,
        uuid: params.uuid || currentOrg.uuid,
        qte: qte,
        referralId: toltReferral,
        partnerId: toltPartner,
      }).unwrap();

      if (data.redirect_url) {
        window.location.href = data.redirect_url;
      } else {
        console.error("No redirect URL received from checkout session");
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div ref={modalRef}>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Billing Modal"
        className={styles.modal}
        overlayClassName={styles.overlay}
        shouldCloseOnOverlayClick={false}
      >
        <div className={styles.root} id="BillingModalContainer">
          <XIcon
            size={24}
            className={styles.closeIcon}
            onClick={onClose}
            color="white"
          />
          <div className={styles.header}>
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Your new powerful advantage</h1>
              <p className={styles.subtitle}>
                More inspiration, better research. 1800+ top players. Love it or
                cancel in 2 clicks.
              </p>
            </div>

            <div className={styles.tabContainer}>
              <div
                className={`${styles.tab} ${activeMenuItem === "individual" ? styles.tabActive : ""}`}
                onClick={() => handleMenuItemClick("individual")}
              >
                <User />
                <p>Solo</p>
              </div>
              <div
                className={`${styles.tab} ${activeMenuItem === "teams" ? styles.tabActive : ""}`}
                onClick={() => handleMenuItemClick("teams")}
              >
                <Users />
                <p>Team</p>
              </div>
            </div>
          </div>
          <div className={styles.plansContainer}>
            {apiDataPlans &&
              (activeMenuItem === "individual" ? (
                (apiDataPlans as ResponsePlans[]).map((item) => (
                  <React.Fragment key={item.id}>
                    <BillingPlanMonth
                      handleSelectPlan={handleSelectPlan}
                      isProcessing={isProcessing}
                    />
                  </React.Fragment>
                ))
              ) : (
                <BillingPlanTeams
                  sliderValue={sliderValue}
                  handleSliderChange={handleSliderChange}
                  handleSelectPlan={handleSelectPlan}
                  isProcessing={isProcessing}
                />
              ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BillingPage;
